import React from "react";
import PropTypes from 'prop-types';
import settings from "../Story/settings";
import people from "../Story/people/people";

const Name = (props) => {
    const color = props.who.color ? props.who.color : settings.name.defaultColor;
    const style = {color, fontSize: settings.name.fontSize};

    const getName = () => {
        if (typeof props.who !== "string")
            return props.who.name;
        else
            return people[props.who].name;
    };

    return (
        <span style={props.noStyle ? {} : style}>
            {props.nickname ? props.who.nickname : getName()}
        </span>
    )
};

Name.propTypes = {
    who: PropTypes.any.isRequired,
    nickname: PropTypes.bool,
    noStyle: PropTypes.bool,
};

export default Name;